import { EmbeddedQuery } from '../shared/EmbeddedQueryParser';

export class ModularConfigurationRequestQuotePageQuery extends EmbeddedQuery {
  public constructor(
    public code: string,
    public familyId: string,
    embed: boolean,
  ) {
    super();
    this.embed = embed;
  }
}
